import { render, staticRenderFns } from "./TicketPayResult.vue?vue&type=template&id=d72328c2&scoped=true&"
import script from "./TicketPayResult.vue?vue&type=script&lang=js&"
export * from "./TicketPayResult.vue?vue&type=script&lang=js&"
import style0 from "./TicketPayResult.vue?vue&type=style&index=0&id=d72328c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72328c2",
  null
  
)

export default component.exports